// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Realtime subscriptions per data sync collaborativo ======
// Quando due admin lavorano contemporaneamente, le modifiche dell'uno
// arrivano in push all'altro senza dover ricaricare. Pattern analogo a
// notifications.js ma esteso a clienti, accessi, scadenze, contratti.
//
// Strategia: refresh selettivo (refreshClient) sulla riga toccata.
// Debounce per evitare flood quando arrivano molti eventi in fila
// (es. saveClient che cancella+reinsert accessi).

let _realtimeChannel = null;
const _pendingRefreshes = new Set(); // cliente_id da ricaricare
let _refreshTimer = null;

const _suppressOwn = {
  // Map cliente_id -> timestamp dell'ultima nostra mutation, per ignorare
  // gli echo dei nostri stessi update arrivati via realtime
  byClienteId: new Map()
};

/** Chiamato da api.* quando facciamo una mutation, per supprimere l'echo realtime. */
function markOwnMutation(cliente_id, ttl = 1500) {
  if (!cliente_id) return;
  _suppressOwn.byClienteId.set(cliente_id, Date.now() + ttl);
  // Auto-cleanup
  setTimeout(() => {
    const t = _suppressOwn.byClienteId.get(cliente_id);
    if (t && t <= Date.now()) _suppressOwn.byClienteId.delete(cliente_id);
  }, ttl + 500);
}

function shouldSuppress(cliente_id) {
  const t = _suppressOwn.byClienteId.get(cliente_id);
  if (!t) return false;
  if (Date.now() > t) {
    _suppressOwn.byClienteId.delete(cliente_id);
    return false;
  }
  return true;
}

function scheduleClientRefresh(cliente_id) {
  if (!cliente_id) return;
  if (shouldSuppress(cliente_id)) return;
  _pendingRefreshes.add(cliente_id);
  if (_refreshTimer) clearTimeout(_refreshTimer);
  _refreshTimer = setTimeout(flushPendingRefreshes, 800);
}

async function flushPendingRefreshes() {
  if (!_pendingRefreshes.size) return;
  const ids = [..._pendingRefreshes];
  _pendingRefreshes.clear();
  _refreshTimer = null;

  for (const cliId of ids) {
    // Trova il nome cliente dall'id (con la lookup esistente)
    let nome = null;
    for (const [n, id] of _clientIdByName.entries()) {
      if (id === cliId) {
        nome = n;
        break;
      }
    }
    if (!nome) {
      // Cliente nuovo che non conosciamo: full reload
      try {
        await loadStateFromSupabase();
      } catch (e) {
        console.warn('full refresh on new client failed', e);
      }
      // Rerender mirato
      if (typeof renderClienti === 'function') renderClienti();
      if (typeof renderDashboard === 'function') renderDashboard();
      continue;
    }
    try {
      await refreshClient(nome);
    } catch (e) {
      console.warn('refresh client failed', nome, e);
    }
  }

  // Rerender della vista corrente
  const activeView = document.querySelector('.nav-item.active')?.dataset.view;
  if (activeView === 'clienti' && typeof renderClienti === 'function') renderClienti();
  else if (activeView === 'risorse' && typeof renderRisorse === 'function') renderRisorse();
  else if (activeView === 'risorsa-detail' && typeof renderRisorsaDetail === 'function')
    renderRisorsaDetail();
  else if (activeView === 'azioni' && typeof renderAzioni === 'function') renderAzioni();
  else if (activeView === 'scadenze' && typeof renderScadenze === 'function') renderScadenze();
  else if (activeView === 'dashboard' && typeof renderDashboard === 'function') renderDashboard();
  else if (activeView === 'pm' && typeof renderPM === 'function') renderPM();

  // Toast leggero per segnalare che e' arrivato un push (silenzioso se molti)
  if (typeof toast === 'function' && ids.length === 1) toast('↻ Aggiornamento da un altro utente');
  else if (typeof toast === 'function' && ids.length > 1)
    toast(`↻ ${ids.length} aggiornamenti da altri utenti`);
}

function startDataRealtime() {
  stopDataRealtime();
  if (!isAdmin && typeof isAdmin !== 'function') return;
  if (typeof isAdmin === 'function' && !isAdmin()) return; // utenti normali: solo notifiche

  _realtimeChannel = sb
    .channel('mase-data')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'clienti' }, (payload) => {
      const id = payload.new?.id || payload.old?.id;
      scheduleClientRefresh(id);
    })
    .on('postgres_changes', { event: '*', schema: 'public', table: 'accessi' }, (payload) => {
      const id = payload.new?.cliente_id || payload.old?.cliente_id;
      scheduleClientRefresh(id);
    })
    .on('postgres_changes', { event: '*', schema: 'public', table: 'contratti' }, (payload) => {
      const id = payload.new?.cliente_id || payload.old?.cliente_id;
      scheduleClientRefresh(id);
    })
    .on('postgres_changes', { event: '*', schema: 'public', table: 'scadenze' }, (payload) => {
      const id = payload.new?.cliente_id || payload.old?.cliente_id;
      scheduleClientRefresh(id);
    })
    .on('postgres_changes', { event: '*', schema: 'public', table: 'referenti' }, (payload) => {
      const id = payload.new?.cliente_id || payload.old?.cliente_id;
      scheduleClientRefresh(id);
    })
    .on('postgres_changes', { event: '*', schema: 'public', table: 'documenti' }, (payload) => {
      const id = payload.new?.cliente_id || payload.old?.cliente_id;
      scheduleClientRefresh(id);
    })
    .subscribe((status) => {
      if (status === 'SUBSCRIBED') console.info('[realtime] data channel connected');
      else if (status === 'CLOSED' || status === 'CHANNEL_ERROR')
        console.warn('[realtime] data channel status:', status);
    });
}

function stopDataRealtime() {
  try {
    if (_realtimeChannel) sb.removeChannel(_realtimeChannel);
  } catch {}
  _realtimeChannel = null;
  if (_refreshTimer) {
    clearTimeout(_refreshTimer);
    _refreshTimer = null;
  }
  _pendingRefreshes.clear();
}

Object.assign(globalThis, {
  startDataRealtime,
  stopDataRealtime,
  markOwnMutation,
  scheduleClientRefresh
});
export {};
